export const lv = {
  "REQUIRED_ACTION_KeepCapturing": "Turpiniet iemūžināt",
  "REQUIRED_ACTION_PauseCapturing": "Pauze uzņemšana",
  "REQUIRED_ACTION_Close": "Tuvs",
  "REQUIRED_ACTION_Error": "Kļūda",
  "REQUIRED_ACTION_AGREE": "Piekrītu",
  "REQUIRED_ACTION_DISAGREE": "Nepiekrītu",
  "LIVENESS_ACTION_Smile": "Smaids",
  "LIVENESS_ACTION_Frown": "Noraustīties",
  "LIVENESS_ACTION_Tilt Left": "Skaties pa kreisi",
  "LIVENESS_ACTION_Tilt Right": "Skaties pa labi",
  "LIVENESS_ACTION_Tilt Up": "Uzskatīt uz augšu",
  "LIVENESS_ACTION_Tilt Down": "Skaties uz leju",
  "LIVENESS_ACTION_Look Straight": "Skaties uz priekšu",
  "LIVENESS_ACTION_No Action": "Nav darbības",
  "LIVENESS_ACTION_PROCESSING_LIVENESS": "Apstrādes dzīvotspēja",
  "LIVENESS_RESULT_Thank you!.Failed": "Neizdevās",
  "LIVENESS_RESULT_Thank you!.Passed": "Pārgāja",
  "LIVENESS_RESULT_Thank you!.ActionTimedOut": "Darbība ir izbeigusies.",
  "LIVENESS_RESULT_Thank you!.Interrupted": "Pārtraukts",
  "LIVENESS_RESULT_Thank you!.Undefined": "Nenoteikts",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TITLE": "Skatieties taisni uz priekšu",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TEXT": "Visu laiku skatieties uz ekrānu",
  "LIVENESS_ACTION_LOOK_LEFT_TITLE": "Nedaudz pagrieziet galvu uz kreiso pusi",
  "LIVENESS_ACTION_LOOK_LEFT_TEXT": "Visu laiku skatieties uz ekrānu",
  "LIVENESS_ACTION_LOOK_RIGHT_TITLE": "Nedaudz pagrieziet galvu pa labi",
  "LIVENESS_ACTION_LOOK_RIGHT_TEXT": "Visu laiku skatieties uz ekrānu",
  "LIVENESS_ACTION_LOOK_UP_TITLE": "Nedaudz pagrieziet galvu uz augšu",
  "LIVENESS_ACTION_LOOK_UP_TEXT": "Visu laiku turiet acis uz ekrāna",
  "LIVENESS_ACTION_LOOK_DOWN_TITLE": "Nedaudz pagrieziet galvu uz leju",
  "LIVENESS_ACTION_LOOK_DOWN_TEXT": "Visu laiku turiet acis uz ekrāna",
  "LIVENESS_ACTION_SMILE_TITLE": "Smaidiet",
  "LIVENESS_ACTION_SMILE_TEXT": "Visu laiku skatieties uz ekrānu",
  "LIVENESS_ACTION_FROWN_TITLE": "Uzmavas",
  "LIVENESS_ACTION_FROWN_TEXT": "Visu laiku turiet acis uz ekrāna",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE": "Ak, tu esi pārāk tuvu.",
  "PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE": "Ak, tu esi pārāk tuvu.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE": "Mēs nevaram noteikt seju attēlā. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE": "Ak... Tu esi pārāk tālu.",
  "PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE": "Ak... kaut kas nogāja greizi.",
  "ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES": "Mēs nevaram attēlā noteikt seju. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE": "Ak... Mēs nevaram noteikt seju.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_None_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_None": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE": "Ak... kaut kas nogāja greizi.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META": "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  "INITIALIZING_TITLE": "Inicializēšana",
  "INITIALIZING_DESCRIPTION": "Pārbauda aparatūras iespējas, lūdzu, uzgaidiet...",
  "JOURNEY_STATE_STARTED": "Sākts",
  "JOURNEY_STATE_INPROGRESS": "Darbībā",
  "JOURNEY_STATE_ENDED": "Beidzās",
  "INFO_JOURNEY_STATE": "Valsts",
  "INFO_JOURNEY_ACTION": "Darbība",
  "INFO_JOURNEY_ACTION_ATTEMPT": "Darbības mēģinājums",
  "INFO_JOURNEY_ID": "Ceļojuma ID",
  "INFO_JOURNEY_RESULT": "Rezultāts",
  "RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE": "Rezultāta ziņojums",
  "RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE": "Jūsu norādītais ID bija novecojis — izmēģiniet kaut ko citu",
  "INFO_JOURNEY_REFERENCE": "Atsauce",
  "FLOW_STATE_NONE": "Neviens",
  "FLOW_STATE_IDENTITY:FRONT": "Priekšējā puse",
  "FLOW_STATE_IDENTITY:BACK": "Aizmugure",
  "FLOW_STATE_ADDRESS": "Adrese",
  "FLOW_STATE_SELFIE": "Pašportrets",
  "FLOW_STATE_LIVENESS": "Dzīvums",
  "FLOW_STATE_COVID": "Covid",
  "PROVIDER_TITLE_CAMERA": "Kamera",
  "PROVIDER_TITLE_CROPPER": "Agris.",
  "PROVIDER_TITLE_FILESYSTEM_ID": "Augšupielādējiet sava personu apliecinoša dokumenta fotoattēlu",
  "PROVIDER_TITLE_FILESYSTEM_FACEMATCH": "Augšupielādējiet savu fotoattēlu",
  "PROVIDER_TITLE_FILESYSTEM_ADDRESS": "Augšupielādējiet sava adreses apliecinājuma fotoattēlu",
  "PROVIDER_TITLE_FILESYSTEM_COVID": "Augšupielādējiet sava Covid dokumenta fotoattēlu",
  "PROVIDER_TITLE_GATEWAY": "Vārti",
  "PROVIDER_TITLE_LIVENESS": "Dzīvums",
  "PROVIDER_TITLE_LOGIN": "Pieteikšanās",
  "PROVIDER_TITLE_RESULTS": "Rezultāti",
  "PROVIDER_TITLE_SCANNER": "Skenējiet savu personu apliecinošu dokumentu",
  "PROVIDER_TITLE_VIEW_ID": "Pārbaudiet sava personu apliecinoša dokumenta priekšskatījumu",
  "PROVIDER_TITLE_VIEW_FACEMATCH": "Pārbaudiet sava pašbildes priekšskatījumu",
  "PROVIDER_TITLE_VIEW_ADDRESS": "Pārbaudiet adreses apliecinājuma priekšskatījumu",
  "ROVIDER_TITLE_VIEW_COVID": "Pārbaudiet sava Covid priekšskatījumu",
  "PROVIDER_SUBTITLE_FILESYSTEM_ID": "Lūdzu, augšupielādējiet sava personu apliecinoša dokumenta fotoattēlu, kas ir skaidrs, fokusēts, neaizsegts un tieši pretī.",
  "PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH": "Lūdzu, augšupielādējiet savu fotoattēlu, kas ir skaidrs, fokusēts, neaizsegts un tieši pretī",
  "PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS": "Lūdzu, augšupielādējiet sava dokumenta fotoattēlu, kas ir skaidrs, fokusēts, neaizsegts un tieši pretī.",
  "PROVIDER_SUBTITLE_FILESYSTEM_COVID": "Lūdzu, augšupielādējiet sava dokumenta fotoattēlu, kas ir skaidrs, fokusēts, neaizsegts un tieši pretī.",
  "PROVIDER_SUBTITLE_SCANNER_ID": "Novietojiet savu personu apliecinošā dokumenta fotoattēla lapu ar priekšpusi uz leju uz skenera.",
  "PROVIDER_SUBTITLE_VIEW_ID": "Lūdzu, pārbaudiet, vai jūsu dokumenta priekšskatījums ir skaidrs, fokusēts, nav aizsegts un tieši pretī.",
  "PROVIDER_SUBTITLE_VIEW_FACEMATCH": "Lūdzu, pārbaudiet, vai pašbildes priekšskatījums ir skaidrs, fokusēts, nav aizsegts un ir tieši uz priekšu.",
  "PROVIDER_SUBTITLE_VIEW_ADDRESS": "Lūdzu, pārbaudiet, vai jūsu dokumenta priekšskatījums ir skaidrs, fokusēts, nav aizsegts un tieši pretī.",
  "PROVIDER_SUBTITLE_VIEW_COVID": "Lūdzu, pārbaudiet, vai jūsu dokumenta priekšskatījums ir skaidrs, fokusēts, nav aizsegts un tieši pretī.",
  "PROVIDER_TITLE_SMART_CAPTURE": "Viedā uztveršana",
  "PROVIDER_TITLE_JOURNEY_SELECT": "Izvēlieties ceļojumu",
  "PROVIDER_TITLE_TERMS_AND_CONDITIONS": "Noteikumi un nosacījumi",
  "PROVIDER_TITLE_USER_INPUT": "Lūdzu, aizpildiet šo veidlapu",
  "FILESYSTEM_SUPPORTED_TYPES_FIRST": "Pieņemamie formāti:",
  "FILESYSTEM_SUPPORTED_TYPES_LIST": "JPG, PNG, PDF",
  "FILESYSTEM_SUPPORTED_TYPES_PDF": "PDF",
  "FILESYSTEM_SUPPORTED_TYPES_SECOND": "(ja tas ir",
  "FILESYSTEM_SUPPORTED_TYPES_THIRD": "tiks apstrādāta tikai pirmā lapa)",
  "FILESYSTEM_SUPPORTED_TYPES_START_SELFIE": "Pieņemamie formāti: JPG, PNG",
  "FILESYSTEM_MAX_FILE_SIZE": "Faila lielums: mēs pieņemam jebkuru failu, kas ir mazāks par",
  "FILESYSTEM_MAX_FILE_SIZE_NUMBER": "7,5 MB",
  "FILESYSTEM_CHECK_FILE_TOO_BIG": "Jūsu fails ir pārāk liels. Lūdzu, augšupielādējiet failu, kas ir mazāks par 7,5 MB.",
  "FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT": "Jūsu failam ir nepareizs formāts. Lūdzu, augšupielādējiet vienu no pieņemtajiem formātiem.",
  "FILESYSTEM_IDENTITY_DOCUMENT": "Personu apliecinošs dokuments",
  "FILESYSTEM_FACEMATCH": "Face Match",
  "FILESYSTEM_ADDRESS": "Adreses apliecinājums",
  "FILESYSTEM_COVID": "Covid",
  "FILESYSTEM_DRAG_DROP": "Velciet un nometiet",
  "FILESYSTEM_OR": "vai",
  "FILESYSTEM_CHOOSE": "Izvēlieties failu",
  "FILESYSTEM_UPLOADING": "Notiek augšupielāde...",
  "TRIPLESCAN_GUIDANCE_TRYAGAIN": "Mēģiniet vēlreiz",
  "FAILURE_REASON_REFER": "Jūsu personu apliecinoša dokumenta validācija neizdevās.",
  "FAILURE_REASON_EXPIRED": "Jūsu personu apliecinošam dokumentam ir beidzies derīguma termiņš.",
  "FAILURE_REASON_NOT_ACCEPTED": "Jūsu personu apliecinošs dokuments nav pieņemts dokumenta veids.",
  "FAILURE_REASON_NOT_SUPPORTED": "Jūsu personu apliecinošu dokumentu nevarēja klasificēt vai tas netiek atbalstīts.",
  "PLEASE_TRY_AGAIN_REFER": "Lūdzu, mēģiniet vēlreiz.",
  "PLEASE_TRY_AGAIN_EXPIRED": "Lūdzu, mēģiniet vēlreiz, izmantojot derīgu dokumentu.",
  "PLEASE_TRY_AGAIN_NOT_ACCEPTED": "Lūdzu, mēģiniet vēlreiz ar citu dokumentu.",
  "PLEASE_TRY_AGAIN_NOT_SUPPORTED": "Lūdzu, mēģiniet vēlreiz.",
  "BLUR_CHECK_REASON": "Blur - dokuments ir neskaidrs;",
  "GLARE_CHECK_REASON": "Atspīdums - dokuments nav nolasāms spilgta gaismas avota dēļ;",
  "RESOLUTION_CHECK_REASON": "Zema izšķirtspēja - dokuments nepareizi aizpilda rāmi;",
  "EDGES_CHECK_REASON": "Trūkst malas - dokuments nav pareizi novietots rāmī;",
  "VALIDATION_FAILED": "Validācija neizdevās",
  "VALIDATION_FAILED_REASON_DOC_UNKNOWN": "- dokuments nav zināms.",
  "VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED": "- dokuments nav pieņemts.",
  "VALIDATION_FAILED_REASON_DOC_EXPIRED": "- dokumentam beidzies derīguma termiņš.",
  "PREVIEW_INFO_TITLE_ID": "Labu un sliktu fotoattēlu piemēri",
  "PREVIEW_INFO_GOOD": "Labi",
  "PREVIEW_INFO_BAD": "Slikti",
  "PREVIEW_INFO_GOOD_EXAMPLE_ID": "Fotoattēls ir dzidrs, fokusā un tieši ar seju.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID": "Fotoattēlā jābūt redzamiem visiem četriem stūriem.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ID": "Dokumentu nedrīkst aizsegt.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID": "Fotoattēls nedrīkst būt izplūdis.",
  "PREVIEW_INFO_TITLE_FACEMATCH": "Padomi labas kvalitātes pašbildei",
  "PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH": "Pašbilde ir skaidra, fokusēta un tieši pretī.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH": "Pašbildē ir jāparāda visa seja.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH": "Seju nedrīkst aizsegt.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH": "Pašbilde nedrīkst būt izplūdusi.",
  "PREVIEW_INFO_TITLE_ADDRESS": "Padomi labas kvalitātes fotoattēlam",
  "PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS": "Fotoattēls ir dzidrs, fokusā un tieši ar seju.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS": "Fotoattēlā jābūt redzamiem visiem četriem stūriem.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS": "Dokumentu nedrīkst aizsegt.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS": "Fotoattēls nedrīkst būt izplūdis.",
  "PREVIEW_INFO_TITLE_COVID": "Padomi labas kvalitātes fotoattēlam",
  "PREVIEW_INFO_GOOD_EXAMPLE_COVID": "Fotoattēls ir dzidrs, fokusā un tieši ar seju.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID": "Fotoattēlā jābūt redzamiem visiem četriem stūriem.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID": "Dokumentu nedrīkst aizsegt.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID": "Fotoattēls nedrīkst būt izplūdis.",
  "ATTEMPTS_REMAINING": "Atlikušo mēģinājumu skaits:",
  "CAMERA_CAPTURE": "Ieslēdziet kameru",
  "CAMERA_CAPTURE_START_BUTTON": "Sāciet automātisko uzņemšanu",
  "CAMERA_CAPTURE_CAPTION": "Lai sāktu, noklikšķiniet uz Sākt automātisko uzņemšanu",
  "CAMERA_PREVIEW_START": "Ieslēdziet kameru, lai sāktu automātisko uzņemšanu",
  "CAMERA_CONDITION_BLUR": "Atklāts aizmiglojums",
  "CAMERA_CONDITION_CAPTURING": "Tveršana",
  "CAMERA_CONDITION_UPLOADING": "Notiek augšupielāde...Lūdzu, uzgaidiet",
  "CAMERA_CONDITION_ALIGNMENT": "Dokuments nav rāmī",
  "CAMERA_CONDITION_GLARE": "Atspīdums konstatēts",
  "VERIFYING_TITLE": "Notiek pārbaude...",
  "PREPARING_PREVIEW_TITLE": "Notiek priekšskatījuma sagatavošana...",
  "CAMERA_CONDITION_LOW_RESOLUTION": "Dokuments pārāk tālu",
  "CAMERA_LOADING": "Notiek kameras atvēršana...",
  "CAMERA_SMARTCAPTURE_ON": "AUTOMĀTISKĀ UZŅEMŠANA — IESL",
  "CAMERA_SMARTCAPTURE_OFF": "AUTOMĀTISKĀ UZŅEMŠANA — IZSL",
  "CAMERA_CAPTURE_FRONT": "Novietojiet fotoattēla pusi no sava identifikācijas dokumenta rāmī zemāk.",
  "CAMERA_MANUAL_CAPTURE_FRONT": "Novietojiet savu personu apliecinošu dokumentu rāmī un noklikšķiniet uz tālāk esošās pogas",
  "CAMERA_CAPTURE_BACK": "Novietojiet personu apliecinoša dokumenta AIZMUGURU rāmī",
  "CAMERA_CAPTURE_SELFIE_CAPTION": "Novietojiet savu seju ovālā, skatieties tieši kamerā un noklikšķiniet uz tālāk esošās pogas, lai uzņemtu pašbildi.",
  "AMERA_CAPTURE_ADDRESS_CAPTION": "Novietojiet savu adreses apliecinājumu rāmī un noklikšķiniet uz tālāk esošās pogas, lai uzņemtu fotoattēlu.",
  "CAMERA_CAPTURE_COVID_CAPTION": "Novietojiet savu Covid dokumentu rāmī un noklikšķiniet uz tālāk esošās pogas, lai uzņemtu fotoattēlu.",
  "CAMERA_PREVENT_GLARE_HINT": "Pārvietojiet dokumentu tālāk no tiešiem gaismas avotiem.",
  "CAMERA_PREVENT_BLUR_HINT": "Turiet dokumentu vai ierīci stabili.",
  "CAMERA_PREVENT_LOW_RES_HINT": "Pilnībā ievietojiet dokumentu rāmī.",
  "CROPPER_RETRY": "Mēģiniet vēlreiz",
  "CROPPER_UPLOAD": "Augšupielādēt",
  "CROPPER_UPLOADING": "Notiek augšupielāde...",
  "FILESYSTEM_SELECT": "Izvēlieties",
  "FILESYSTEM_DROP_IMAGE": "vai Nomest attēlu",
  "GATEWAY_CAMERA": "Kamera iespējota",
  "GATEWAY_CANCEL": "Atcelt ceļojumu",
  "LIVENESS_START": "Sāciet dzīvīgumu",
  "PASSIVE_LIVENESS_START": "Uzņemiet attēlu",
  "LOGIN_USERNAME": "Lietotājvārds",
  "LOGIN_PASSWORD": "Parole",
  "LOGIN_SUBMIT": "Iesniegt",
  "RESULTS_DOCUMENTS": "Dokumenti",
  "RESULTS_DOCUMENTS_NONE": "Nav atrasts",
  "RESULTS_DOCUMENT_TYPE": "Dokumenta veids",
  "RESULTS_DOCUMENT_RESULT": "Dokumenta rezultāts",
  "RESULTS_EXTRACTED_FIELDS_NONE": "Sīkāka informācija par rezultātiem",
  "RESULTS_DETAILS_NONE": "Nav atrasts",
  "RESULTS_NEW_JOURNEY": "Sākt jaunu ceļojumu",
  "RESULTS_NO_INFORMATION": "Nav informācijas par šo braucienu",
  "RESULTS_LOGOUT": "Izrakstīties",
  "RESULTS_HIGH_LEVEL_Aborted": "Pārtraukts",
  "RESULTS_HIGH_LEVEL_TCCDISAGREE": "Pārtraukts T&C's",
  "RESULTS_HIGH_LEVEL_Expired": "Nobriedis",
  "RESULTS_HIGH_LEVEL_NotAccepted": "Nav pieņemts",
  "RESULTS_HIGH_LEVEL_NotSupported": "Nav atbalstīts",
  "RESULTS_HIGH_LEVEL_Notsupported": "Nav atbalstīts",
  "RESULTS_HIGH_LEVEL_Passed": "Pārgāja",
  "RESULTS_HIGH_LEVEL_Refer": "Atsauce",
  "RESULTS_HIGH_LEVEL_Undefined": "Nenoteikts",
  "RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT": "Kopējais dzīvības rezultāts",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK": "Dokumenta priekšējās puses veida pārbaude",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK": "Dokumenta aizmugures pārbaude",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY": "Dokumentu bloķēšanas politika",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY": "Dokumenta derīguma termiņš",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT": "Dokumentu atbalsts",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION": "Dokumentu validācija",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY": "Dokumentu pierādījumu politika",
  "RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION": "Facematch Validācija",
  "RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE": "Nepilngadīgo noteikums",
  "ESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED": "Nepieciešamie panākumi",
  "RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK": "Covid pases saderības pārbaude",
  "RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK": "Datu pārbaudes",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED": "Neizdevās",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED": "Nav nepieciešams",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED": "Pārgāja",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED": "Nepārprotiet",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED": "Nenoteikts",
  "ADDITIONAL_CHECKS_DETAILS": "Papildu pārbaudes",
  "ADDITIONAL_CHECKS_DETAILS_NONE": "Nav atrasts",
  "ADDITIONAL_CHECKS_DETAIL_DATACHECKS": "Datu pārbaudes",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK": "Atgriezeniskās pārbaudes",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA": "NAV",
  "GBG_SCORES": "GBG rezultāti",
  "GBG_TRUST_SCORE": "GBG uzticības rādītājs",
  "GBG_SCORE": "GBG rezultāts",
  "VIEW_RETRY": "Izmaiņu foto",
  "VIEW_CROP": "Kultūra",
  "VIEW_CROPPING": "Apgriešana...",
  "VIEW_UPLOAD": "Augšupielādēt",
  "VIEW_UPLOADING": "Augšupielāde...",
  "SMART_CAPTURE_INITIALIZING": "Sākt",
  "SMART_CAPTURE_START": "Inicializē Smart Capture, Lūdzu, Gaidiet...",
  "SCANNER_DESC_AVAILABLE": "Skenētājs ir pieejams. Ielieciet savu dokumentu skenerī.",
  "SCANNER_DESC_PROCESSING": "Attēls tiek apstrādāts ar serveri.",
  "SCANNER_DESC_SCANNING": "Attēls tiek skenēts ar ierīci.",
  "SCANNER_DESC_DISCONNECTED": "Skenētājs ir atvienots no tīkla.",
  "SCANNER_DESC_NOT_CONNECTED": "Skenētājs nav pievienots.",
  "SCANNER_DESC_OFFLINE": "Skenētājs ir bezsaistē.",
  "SCANNER_DESC_BUSY": "Skenētājs tiek izmantots citu lietotāju lokālajā tīklā.",
  "SCANNER_DESC_WAITING": "Gaidot, lai tiktu izveidota savienojums.",
  "SCANNER_DESC_LOADING": "Lūdzu, uzgaidiet...",
  "SCANNER_TITLE_SCANNING": "SKENĒŠANA...",
  "SCANNER_TITLE_DISCONNECTED": "ATVĒLĒTS",
  "SCANNER_TITLE_NOT_CONNECTED": "NAV PIEVIENOJIES",
  "SCANNER_TITLE_OFFLINE": "Skeneris bezsaistē",
  "SCANNER_TITLE_BUSY": "Skeneris aizņemts",
  "SCANNER_TITLE_WAITING": "Gaidīšana",
  "SCANNER_ACTION_REGISTER": "Reģistrs",
  "SCANNER_ACTION_RELEASE": "Izdošana",
  "CANCEL_JOURNEY": "Atcelt",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE": "Augšupielādējiet fotoattēlu tā vietā",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE": "Uzņemiet fotoattēlu tā vietā",
  "JOURNEY_SELECT_CONTINUE": "Turpināt",
  "HELP_MODAL_AUTOCAPTURE_TITLE": "Kā nofotografēt savu personu apliecinošu dokumentu",
  "HELP_MODAL_AUTOCAPTURE_SUBTITLE": "Ja ir ieslēgta automātiskā uzņemšana, uzņemšanas ekrāns automātiski uzņems jūsu dokumenta fotoattēlu, kad tas būs atzinis, ka tā kvalitāte ir pietiekami laba.",
  "HELP_MODAL_AUTOCAPTURE_TIPS": "Padomi, kā uzņemt labas kvalitātes fotoattēlu",
  "HELP_MODAL_AUTOCAPTURE_GLARE_TITLE": "Izvairieties no atspīduma",
  "HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE": "Novietojiet dokumentu tālāk no tiešiem gaismas avotiem.",
  "HELP_MODAL_AUTOCAPTURE_FAR_TITLE": "Dokuments ir pārāk tālu",
  "AUTOCAPTURE_FAR_SUBTITLE": "Pilnībā ievietojiet dokumentu rāmī.",
  "AUTOCAPTURE_BLUR_TITLE": "Novērst izplūšanu",
  "HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE": "Turiet dokumentu vai ierīci nekustīgi.",
  "HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE": "Joprojām cīnāties ar grūtībām? Uzņemiet fotoattēlu, izmantojot manuālo uzņemšanu",
  "HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE": "Manuālā uzņemšana",
  "HELP_MODAL_SELFIE_TITLE": "Kā uzņemt selfiju",
  "HELP_MODAL_SELFIE_SUBTITLE": "Skatieties tieši kamerā un noklikšķiniet uz manuālās uzņemšanas pogas.",
  "HELP_MODAL_POA_TITLE": "Kā nofotografēt adreses apliecinājumu",
  "HELP_MODAL_POA_SUBTITLE": "Novietojiet dokumentu kadrā un noklikšķiniet uz uzņemšanas pogas, lai uzņemtu dokumenta fotoattēlu.",
  "HELP_MODAL_POA_TIPS": "Padomi, kā uzņemt labas kvalitātes fotoattēlu",
  "HELP_MODAL_POA_GLARE_TITLE": "Izvairieties no atspīduma",
  "HELP_MODAL_POA_GLARE_SUBTITLE": "Novietojiet dokumentu tālāk no tiešiem gaismas avotiem.",
  "HELP_MODAL_POA_FAR_TITLE": "Pārāk tālu ejošs dokuments",
  "HELP_MODAL_POA_FAR_SUBTITLE": "Pilnībā ievietojiet dokumentu rāmī.",
  "HELP_MODAL_POA_BLUR_TITLE": "Novērst izplūšanu",
  "HELP_MODAL_POA_BLUR_SUBTITLE": "Turiet dokumentu vai ierīci nekustīgi.",
  "HELP_MODAL_POA_MANUAL_CAPTURE": "Joprojām cīnāties ar grūtībām? Ieslēdziet manuālo uzņemšanu",
  "HELP_MODAL_POA_TURN_MANUAL_CAPTURE": "Manuālā uzņemšana",
  "HELP_MODAL_COVID_TITLE": "Kā nofotografēt Covid dokumentu",
  "HELP_MODAL_COVID_SUBTITLE": "Novietojiet dokumentu rāmī un noklikšķiniet uz uzņemšanas pogas, lai uzņemtu dokumenta fotoattēlu.",
  "HELP_MODAL_COVID_TIPS": "Padomi, kā uzņemt labas kvalitātes fotoattēlu",
  "HELP_MODAL_COVID_GLARE_TITLE": "Novērsiet atspīdumu",
  "HELP_MODAL_COVID_GLARE_SUBTITLE": "Novietojiet dokumentu tālāk no tiešiem gaismas avotiem.",
  "HELP_MODAL_COVID_FAR_TITLE": "Dokuments ir pārāk tālu",
  "HELP_MODAL_COVID_FAR_SUBTITLE": "Pilnībā ievietojiet dokumentu rāmī.",
  "HELP_MODAL_COVID_BLUR_TITLE": "Izvairieties no izplūšanas",
  "HELP_MODAL_COVID_BLUR_SUBTITLE": "Turiet dokumentu vai ierīci nekustīgi.",
  "HELP_MODAL_COVID_MANUAL_CAPTURE": "Joprojām cīnāties ar grūtībām? Ieslēdziet manuālo uzņemšanu",
  "HELP_MODAL_COVID_TURN_MANUAL_CAPTURE": "Manuālā uzņemšana",
  "HELP_MODAL_NEED_HELP": "Nepieciešama palīdzība?",
  "EXCEPTION": "Ir noticis neparedzēts izņēmums",
  "EXCEPTION_AUTHORIZATION": "Neautorizēts",
  "EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED": "Jūsu konts nav autorizēts piekļūt šim resursam",
  "EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID": "Lietotājvārda un paroles kombinācija nav derīga",
  "EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED": "Lai izmantotu šo funkcionalitāti, ir jāaktivizē autentificēšana",
  "EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED": "Jūs neesat autorizēts šim procesam",
  "EXCEPTION_BAD_REQUEST": "Slikts pieprasījums ar statusa kodu 400",
  "EXCEPTION_BAD_REQUEST_INVALID_IMAGE": "Nav derīgs attēls",
  "EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE": "Ceļojums gaida atbildi",
  "EXCEPTION_FLOW_STATE_JOURNEY_ENDED": "Nevar nosūtīt pieprasījumus. Brauciens ir beidzies",
  "EXCEPTION_FLOW_STATE_MISSING": "Nav atrasts plūsmas stāvoklis",
  "EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION": "Atgriezeniskais izsaukums jābūt derīgai funkcijai.",
  "EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING": "Notikuma nosaukumam jābūt virknes vērtībai",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER": "Prioritātei jābūt skaitlim",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER": "Prioritātei jābūt pozitīvam skaitlim",
  "EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR": "Konteinerim jābūt vai nu elementam, vai atlasītājam.",
  "EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID": "Vērtība nav derīga",
  "EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED": "Vērtība ir bojāta.",
  "EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING": "Konfigurācijā jāiekļauj backendUrl parametrs",
  "EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING": "Nodrošinātie parametriem jāsatur koordinātas.",
  "EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING": "Nodrošinātie parametriem jāsatur attēli.",
  "EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING": "Nodrošinātie parametriem jābūt paroles.",
  "EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING": "Nodrošinātie parametriem jābūt lietotājvārdam.",
  "EXCEPTION_MISSING_REQUIRED_FIELD_MISSING": "Lūdzu, aizpildiet visus obligātos laukus",
  "EXCEPTION_POSTCODE_FORMAT_ERROR": "Pasta koda formāts nav derīgs minLength:5 / maxLength:8",
  "EXCEPTION_HOUSENUMBER_FORMAT_ERROR": "Mājas nosaukums/numurs nav derīgs formāts minDilgs:1 / maxDilgs:20",
  "EXCEPTION_STREETNAME_FORMAT_ERROR": "Ielas nosaukums nav derīgs minLength:1 / maxLength:30",
  "EXCEPTION_TOWN_FORMAT_ERROR": "Pilsētas formāts nav derīgs minLength:1 / maxLength:20",
  "EXCEPTION_JOURNEY_DEFINITIONS_MISSING": "Šim kanālam nav pieejamas braucienu definīcijas",
  "EXCEPTION_NETWORK": "Ir noticis tīkla izņēmums, lūdzu, pārbaudiet savienojumu un mēģiniet vēlreiz.",
  "EXCEPTION_PLATFORM_BROWSER_ONLY": "Šo funkciju var izmantot tikai pārlūkprogrammā",
  "EXCEPTION_PLATFORM_UNSUPPORTED": "Jūsu vide neatbalsta šo funkciju",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED": "Kameras atļaujas nav piešķirtas, lūdzu, pārbaudiet pārlūkprogrammas iestatījumus",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE": "Kameras atļaujas nav pieejamas",
  "EXCEPTION_PLATFORM_CAMERA_NOT_READABLE": "Kamerai nav iespējams piekļūt. Lūdzu, aizveriet visas citas lietojumprogrammas un mēģiniet vēlreiz",
  "EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE": "Jūsu ierīcē nav atrasta piemērota kamera",
  "EXCEPTION_SERVER": "Pieprasījums neizdevās ar statusa kodu 500",
  "EXCEPTION_SERVER_UNREACHABLE": "Pieprasījums neizdevās, serveris nav sasniedzams",
  "EXCEPTION_SERVER_DATA_NOT_PERSISTED": "Procesa laikā ir notikusi kļūda. Jūsu dati var netikt saglabāti",
  "EXCEPTION_SERVER_RESULT_NOT_PASSING": "Pašreizējais rezultāts netiek nodots",
  "EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE": "Canvas konteksts nav pieejams",
  "EXCEPTION_TEMPLATE_CONTAINER_MISSING": "Konteinera nav",
  "EXCEPTION_TEMPLATE_ELEMENTS_MISSING": "Trūkst obligāto elementu",
  "EXCEPTION_TEMPLATE_MISSING": "Šablons nav atrasts",
  "EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING": "Nav iespējams atrast avota elementu",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE": "Nevar iegūt ievades pakalpojumu sniedzējus",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED": "Nav norādīti ievades pakalpojumu sniedzēji",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE": "Ievades pakalpojumu sniedzējs nav pieejams",
  "SUPPORTED_DOCUMENT_Account Statement": "Konta izraksts",
  "SUPPORTED_DOCUMENT_Agreement (Tenancy)": "Līgums (Īres līgums)",
  "SUPPORTED_DOCUMENT_Bank Document": "Bankas dokuments",
  "SUPPORTED_DOCUMENT_Bank Letter": "Bankas vēstule",
  "SUPPORTED_DOCUMENT_Bank Statement": "Bankas izraksts",
  "SUPPORTED_DOCUMENT_Benefit Letter": "Pabalsta vēstule",
  "SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)": "Sertifikāts (Dzimšanas, Kāzas, Civilā partnerība)",
  "SUPPORTED_DOCUMENT_Council Document": "Padomes dokuments",
  "SUPPORTED_DOCUMENT_Council Letter": "Padomes vēstule",
  "SUPPORTED_DOCUMENT_Council Tax": "Padomju nodoklis",
  "SUPPORTED_DOCUMENT_Driving License": "Braukšanas atļauja",
  "SUPPORTED_DOCUMENT_Driving Licence": "Braukšanas atļauja",
  "SUPPORTED_DOCUMENT_DWP Document": "DWP Dokuments",
  "SUPPORTED_DOCUMENT_HMRC Document": "HMRC Dokuments",
  "SUPPORTED_DOCUMENT_Information Sheet": "Informācijas lapa",
  "SUPPORTED_DOCUMENT_Insurance Document": "Apdrošināšanas dokuments",
  "SUPPORTED_DOCUMENT_Insurance Letter": "Apdrošināšanas vēstule",
  "SUPPORTED_DOCUMENT_Invoice": "Pavadzīme",
  "SUPPORTED_DOCUMENT_NIC Letter": "NIC Vēstule",
  "SUPPORTED_DOCUMENT_NINO Letter": "NINO vēstule",
  "SUPPORTED_DOCUMENT_Official Document": "Oficiāls dokuments",
  "SUPPORTED_DOCUMENT_Official Letter": "Oficiālais vēstulis",
  "SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)": "Atmaksas vēstule (saistīta ar nodokļiem vai sociālo atbalstu)",
  "SUPPORTED_DOCUMENT_Tax Letter": "Nodokļu vēstule",
  "SUPPORTED_DOCUMENT_Tax Statement": "Nodokļu izziņa",
  "SUPPORTED_DOCUMENT_Tel Bill": "Tēla rēkini",
  "SUPPORTED_DOCUMENT_Tel Letter": "Tel Vēstule",
  "SUPPORTED_DOCUMENT_Telecommunication Document": "Telekomunikāciju dokuments",
  "SUPPORTED_DOCUMENT_TV Licence": "TV licences",
  "SUPPORTED_DOCUMENT_University Letter": "Universitātes vēstule",
  "SUPPORTED_DOCUMENT_Utility Bill": "Komunālā rēķina",
  "SUPPORTED_DOCUMENT_Utility Document": "Utilitātes dokuments",
  "SUPPORTED_DOCUMENT_Utility Letter": "Utilitātes vēstule",
  "SUPPORTED_DOCUMENT_Water Bil": "Ūdens Bils",
  "SUPPORTED_DOCUMENT_Water Document": "Ūdens dokuments",
  "SUPPORTED_DOCUMENT_Agents License": "Aģenta licence",
  "SUPPORTED_DOCUMENT_Electoral Card": "Vēlēšanu karte",
  "SUPPORTED_DOCUMENT_Foreigner Identification Card": "Ārzemnieka identifikācijas karte",
  "SUPPORTED_DOCUMENT_Health Card": "Veselības karte",
  "SUPPORTED_DOCUMENT_Job License": "Darba licence",
  "SUPPORTED_DOCUMENT_Membership Identification Card": "Biedra identifikācijas karte",
  "SUPPORTED_DOCUMENT_Military Identification Card": "Karavīra identifikācijas karte",
  "SUPPORTED_DOCUMENT_National Identification Card": "Nacionālā identifikācijas karte",
  "SUPPORTED_DOCUMENT_Passport": "Pase",
  "SUPPORTED_DOCUMENT_Travel Permit": "Ceļošanas atļauja",
  "SUPPORTED_DOCUMENT_Visa": "Visa",
  "SUPPORTED_DOCUMENT_Weapons Licence": "Ieroču atļauja",
  "SUPPORTED_DOCUMENT_Selfie Photo": "Selfie foto",
  "SUPPORTED_DOCUMENT_Unknown": "Nezināms",
  "SUPPORTED_DOCUMENT_COVIDPAS": "Covid caurlaide",
  "EXTRACTED_FIELDS_AddressFull": "Adrese Pilna",
  "EXTRACTED_FIELDS_AddressCity": "Adrese Pilsēta",
  "EXTRACTED_FIELDS_AddressPostCode": "Adreses pasta indekss",
  "EXTRACTED_FIELDS_LastNameFirstPart": "Uzvārds Pirmā Daļa",
  "EXTRACTED_FIELDS_Sex": "Dzimums",
  "EXTRACTED_FIELDS_BirthPlace": "Dzimšanas vieta",
  "EXTRACTED_FIELDS_IssueNumber": "Problēmas numurs",
  "EXTRACTED_FIELDS_DocumentNumberCheckDigit": "Dokumenta numura pārbaudes cipars",
  "EXTRACTED_FIELDS_BirthDate": "Dzimšanas datums",
  "EXTRACTED_FIELDS_DocumentNumber": "Dokumenta numurs",
  "EXTRACTED_FIELDS_FirstName": "Vārds",
  "EXTRACTED_FIELDS_ArbitraryDigit": "Patvaļīgs cipars",
  "EXTRACTED_FIELDS_FirstNameInitial": "Vārda sākuma burti",
  "EXTRACTED_FIELDS_ExpiryDate": "Derīguma termiņš",
  "EXTRACTED_FIELDS_IssueDate": "Izdošanas datums",
  "EXTRACTED_FIELDS_LastName": "Uzvārds",
  "EXTRACTED_FIELDS_LicenseCategory": "Licences kategorija",
  "EXTRACTED_FIELDS_DocumentCategory": "Dokumentu kategorija",
  "EXTRACTED_FIELDS_DocumentType": "Dokumenta tips",
  "EXTRACTED_FIELDS_NationalityCode": "Nacionālā kods",
  "EXTRACTED_FIELDS_MiddleName": "Otrā vārda",
  "EXTRACTED_FIELDS_FirstIssuanceDate": "Pirmās izdošanas datums",
  "EXTRACTED_FIELDS_SecondLastName": "Otrais uzvārds",
  "EXTRACTED_FIELDS_FullName": "Pilns vārds",
  "EXTRACTED_FIELDS_PersonalNumber": "Personas kods",
  "EXTRACTED_FIELDS_NationalityName": "Nacionālais piederība",
  "EXTRACTED_FIELDS_BarcodeItems": "KodoluS",
  "EXTRACTED_FIELDS_BirthPlaceCity": "Dzimšanas pilsēta",
  "EXTRACTED_FIELDS_BirthPlaceState": "Dzimšanas valsts",
  "EXTRACTED_FIELDS_BirthPlaceCountry": "Dzimšanas valsts",
  "EXTRACTED_FIELDS_MRZFull": "Pilns MRZ",
  "EXTRACTED_FIELDS_MRZLine1": "MRZ Rinda 1",
  "EXTRACTED_FIELDS_MRZLine2": "MRZ Rinda 2",
  "EXTRACTED_FIELDS_MRZLine3": "MRZ Rinda 3",
  "EXTRACTED_FIELDS_ObservationPage": "Novērošanas lapa",
  "EXTRACTED_FIELDS_IssuingAuthority": "Izdošanas iestāde",
  "EXTRACTED_FIELDS_IssuingLocation": "Izdošanas vieta",
  "EXTRACTED_FIELDS_MaritalStatus": "Ģimenes stāvoklis",
  "EXTRACTED_FIELDS_Occupation": "Okupācija",
  "EXTRACTED_FIELDS_AlienNumber": "Svešzemju numurs",
  "EXTRACTED_FIELDS_Employer": "Darba devējs",
  "EXTRACTED_FIELDS_AddressLine1": "Adreses rinda 1",
  "EXTRACTED_FIELDS_AddressLine2": "Adreses rinda 2",
  "EXTRACTED_FIELDS_AddressLine3": "Adreses rinda 3",
  "EXTRACTED_FIELDS_AddressLine4": "Adreses rinda 4",
  "EXTRACTED_FIELDS_AddressState": "Valsts",
  "EXTRACTED_FIELDS_AddressDistrict": "Rajons",
  "EXTRACTED_FIELDS_AddressBuildingNumber": "Ēkas numurs",
  "EXTRACTED_FIELDS_AddressBuildingName": "Ēkas nosaukums",
  "EXTRACTED_FIELDS_AddressStreet": "Iela",
  "EXTRACTED_FIELDS_AddressCountry": "Valsts",
  "EXTRACTED_FIELDS_RefAddressFull": "Atsauce Adrese",
  "EXTRACTED_FIELDS_RefAddressLine1": "Atsauce Adreses rinda 1",
  "EXTRACTED_FIELDS_RefAddressLine2": "Atsauce Adreses rinda 2",
  "EXTRACTED_FIELDS_RefAddressLine3": "Atsauce Adreses rinda 3",
  "EXTRACTED_FIELDS_RefAddressLine4": "Atsauce Adreses rinda 4",
  "EXTRACTED_FIELDS_RefAddressCity": "Atsauce Adrese Pilsēta",
  "EXTRACTED_FIELDS_RefAddressState": "Atsauce Adrese Valsts",
  "EXTRACTED_FIELDS_RefAddressDistrict": "Atsauce Adrese Rajons",
  "EXTRACTED_FIELDS_RefAddressBuildingNumber": "Atsauce Adrese Ēkas numurs",
  "EXTRACTED_FIELDS_RefAddressBuildingName": "Atsauce Adrese Ēkas nosaukums",
  "EXTRACTED_FIELDS_RefAddressSubBuildingName": "Atsauce Adrese Apbūves Nosaucums",
  "EXTRACTED_FIELDS_RefAddressStreet": "Atsauce Adrese iela",
  "EXTRACTED_FIELDS_RefAddressCountry": "Atsauce Adrese Valsts",
  "EXTRACTED_FIELDS_RefAddressPostCode": "Atsauce Adrese Pasta indekss",
  "EXTRACTED_FIELDS_HealthNumber": "Veselības numurs",
  "EXTRACTED_FIELDS_Endorsements": "Apsveikumi",
  "EXTRACTED_FIELDS_Constraints": "Ierobežojumi",
  "EXTRACTED_FIELDS_LicenseMarine": "Licence Jūras",
  "EXTRACTED_FIELDS_Height": "Augstums",
  "EXTRACTED_FIELDS_Weight": "Svars",
  "EXTRACTED_FIELDS_HairColor": "Matu krāsa",
  "EXTRACTED_FIELDS_EyeColor": "Acu krāsa",
  "EXTRACTED_FIELDS_LensData": "Redze",
  "EXTRACTED_FIELDS_SocialSecurityNumber": "Sociālais drošības numurs",
  "EXTRACTED_FIELDS_NationalInsuranceNumber": "Nacionālais apdrošināšanas numurs",
  "EXTRACTED_FIELDS_Race": "Sacīkstes",
  "EXTRACTED_FIELDS_MotherName": "Mātes vārds",
  "EXTRACTED_FIELDS_FatherName": "Tēva vārds",
  "EXTRACTED_FIELDS_Parents": "Vecāki",
  "EXTRACTED_FIELDS_Remarks": "Piezīmes",
  "EXTRACTED_FIELDS_DistinguishingMarks": "Atšķirīgie zīmējumi",
  "EXTRACTED_FIELDS_PeriodOfStay": "Uzturēšanās periods",
  "EXTRACTED_FIELDS_TaxNumber": "Nodokļu numurs",
  "EXTRACTED_FIELDS_Donor": "Ziedotājs",
  "EXTRACTED_FIELDS_RFIDG1": "RFID sirovie datus grupa 1",
  "EXTRACTED_FIELDS_RFIDG2": "RFID sirovie datus grupa 2",
  "EXTRACTED_FIELDS_RFIDG3": "RFID sirovie datus grupa 3",
  "EXTRACTED_FIELDS_RFIDG15": "RFID sirovie datus grupa 4",
  "EXTRACTED_FIELDS_RFIDSOD": "RFID sirovie datus grupa 5",
  "EXTRACTED_FIELDS_PortraitPhoto": "Izgūtais portreta foto",
  "EXTRACTED_FIELDS_Title": "Virsraksts",
  "EXTRACTED_FIELDS_IssueDate2": "Otrās izdošanas datums",
  "EXTRACTED_FIELDS_ExpiryDate2": "Otrā derīguma termiņa",
  "EXTRACTED_FIELDS_LicenseCategory2": "Otrās licences kategorija",
  "EXTRACTED_FIELDS_IssueDate3": "Trešais izdošanas datums",
  "EXTRACTED_FIELDS_ExpiryDate3": "Trešais derīguma termiņš",
  "EXTRACTED_FIELDS_LicenseCategory3": "Trešā licences kategorija",
  "EXTRACTED_FIELDS_IssueDate4": "Ceturtais izdošanas datums",
  "EXTRACTED_FIELDS_ExpiryDate4": "Ceturtais derīguma termiņš",
  "EXTRACTED_FIELDS_LicenseCategory4": "Ceturtais licences kategorija",
  "EXTRACTED_FIELDS_MRZCode1": "MRZ kods 1",
  "EXTRACTED_FIELDS_MRZCode2": "MRZ kods 2",
  "EXTRACTED_FIELDS_MRZStandardType": "MRZ standarta tips",
  "EXTRACTED_FIELDS_AddressStreetSuffix": "Ielas noslēpums",
  "EXTRACTED_FIELDS_AddressStreetType": "Ielas tips",
  "EXTRACTED_FIELDS_AddressUnitNumber": "Adreses vienības numurs",
  "EXTRACTED_FIELDS_LicenseNumber": "Licences numurs",
  "EXTRACTED_FIELDS_AddressStateCode": "Valsts kods",
  "EXTRACTED_FIELDS_AddressStreetTypeAbbreviation": "Ielas saīsinājums",
  "EXTRACTED_FIELDS_AddressUnitType": "Adreses vienības tips",
  "EXTRACTED_FIELDS_AddressDeliveryPointIdentifier": "Piegādes punkta identifikators",
  "EXTRACTED_FIELDS_AgeCategory": "Vecuma kategorija",
  "EXTRACTED_FIELDS_ChildernCount": "Bērnu skaits",
  "EXTRACTED_FIELDS_EntryMode": "Ieraksta režīms",
  "EXTRACTED_FIELDS_VAFNumber": "VAF numurs",
  "EXTRACTED_FIELDS_AddressLine5": "Adreses rinda 5",
  "EXTRACTED_FIELDS_RFIDPortraitPhoto": "RFID Portreta foto",
  "EXTRACTED_FIELDS_RefAddressLine5": "Atsauce Adreses līnija 5",
  "EXTRACTED_FIELDS_RefAddressStateCode": "Atsauce Adrese Valsts",
  "EXTRACTED_FIELDS_RefAddressStreetType": "Atsauce Adrese Ielas Tips",
  "EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation": "Atsauce Adreses ielas tips saīsinājums",
  "EXTRACTED_FIELDS_RefAddressStreetSuffix": "Atsauce Adrese iela Suffix",
  "EXTRACTED_FIELDS_RefAddressUnitNumber": "Atsauce Adrese Vienskaitlis Numurs",
  "EXTRACTED_FIELDS_RefAddressUnitType": "Atsauce Adrese Vienības Tips",
  "EXTRACTED_FIELDS_RefAddressPostcodeType": "Atsauce Adrese Pasta indekss Tips",
  "EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier": "Atsauce Adrese Piegādes punkta identifikators",
  "EXTRACTED_FIELDS_RefAddressPOBoxNumber": "Atsauce Adrese PO kastītes numurs",
  "EXTRACTED_FIELDS_RefAddressDependentLocality": "Atsauce Adrese Atkarīgā teritorija",
  "EXTRACTED_FIELDS_RefAddressDoubleDependentLocality": "Atsauce Adrese Dubultā Atkarīgā Teritorija",
  "EXTRACTED_FIELDS_RefAddressThoroughfare": "Atsauce Adrese Iela",
  "EXTRACTED_FIELDS_RefAddressThoroughfareDesc": "Atsauce Adrese Iela Apraksts",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfare": "Atsauce Adrese Atkarīga Iela",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc": "Atsauce Adrese Atkarīga Iela Apraksts",
  "EXTRACTED_FIELDS_RefAddressSubBuildingNumber": "Atsauce Adrese Papildu Ēkas Numurs",
  "EXTRACTED_FIELDS_AddressSubBuildingNumber": "Ēkas numurs",
  "EXTRACTED_FIELDS_AddressSubBuildingName": "Ēkas nosaukums",
  "EXTRACTED_FIELDS_AddressPostCodeType": "Pasta indeksa tips",
  "EXTRACTED_FIELDS_IssuingAuthorityType": "Izdošanas iestādes tips",
  "EXTRACTED_FIELDS_Signature": "Paraksts",
  "EXTRACTED_FIELDS_Hologram": "Hologrāma",
  "EXTRACTED_FIELDS_CardNumber": "Kartes numurs",
  "EXTRACTED_FIELDS_MiddleNameInitial": "Otrā vārda sākuma burts",
  "EXTRACTED_FIELDS_PermitNumber": "Atļaujas numurs",
  "EXTRACTED_FIELDS_ReferenceNumber": "Atsauce numurs",
  "EXTRACTED_FIELDS_CustomerNumber": "Klienta numurs",
  "EXTRACTED_FIELDS_BOSNumber": "BOS numurs",
  "EXTRACTED_FIELDS_StudentID": "Students identifikācijas numurs",
  "EXTRACTED_FIELDS_MembershipNumber": "Biedra numurs",
  "EXTRACTED_FIELDS_LicenseType": "Licences tips",
  "EXTRACTED_FIELDS_LicenseType2": "Licences tips 2",
  "EXTRACTED_FIELDS_LicenseType3": "Licences tips 3",
  "EXTRACTED_FIELDS_LicenseType4": "Licences tips 4",
  "EXTRACTED_FIELDS_DocumentTypeCode": "Dokumenta veida kods",
  "EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit": "MRZ Pārbaudes cipars",
  "EXTRACTED_FIELDS_MRZBirthDateCheckDigit": "Dzimšanas datuma pārbaudes cipars MRZ",
  "EXTRACTED_FIELDS_MRZExpiryDateCheckDigit": "MRZ Derīguma termiņa pārbaudes cipars",
  "EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit": "MRZ Personas numura pārbaudes cipars",
  "EXTRACTED_FIELDS_MRZCompositeCheckDigit": "MRZ Kompozītais Pārbaudes Cipars",
  "EXTRACTED_FIELDS_SecondaryPortraitPhoto": "Sekundārā portreta fotoattēls",
  "EXTRACTED_FIELDS_Fingerprint": "Pirkstu nospiedums",
  "EXTRACTED_FIELDS_VersionNumber": "Versijas numurs",
  "EXTRACTED_FIELDS_Conditions": "Apgabalos",
  "EXTRACTED_FIELDS_NickName": "Liels vārds",
  "EXTRACTED_FIELDS_AddressApartmentNumber": "Dzīvokļa numurs",
  "EXTRACTED_FIELDS_AddressFloorNumber": "Stāva numurs",
  "EXTRACTED_FIELDS_FirstNameLocal": "Vārds Vietējais",
  "EXTRACTED_FIELDS_LastNameLocal": "Pēdējais vārds Vietējais",
  "EXTRACTED_FIELDS_FullNameLocal": "Pilns vārds Vietējais",
  "EXTRACTED_FIELDS_BirthPlaceLocal": "Dzimšanas vieta Lokāla",
  "EXTRACTED_FIELDS_IssuingAuthorityLocal": "Izdošanas iestāde Lokāla",
  "EXTRACTED_FIELDS_MotherNameLocal": "Mātes Vārds Vietējais",
  "EXTRACTED_FIELDS_FatherNameLocal": "Tēva Vārds Vietējais",
  "EXTRACTED_FIELDS_AddressFullLocal": "Adrese Pilna Vietējā",
  "EXTRACTED_FIELDS_MiddleNameLocal": "Otrā vārda vietējais",
  "EXTRACTED_FIELDS_AddressLine1Local": "Adreses rinda 1 Vietējais",
  "EXTRACTED_FIELDS_AddressLine2Local": "Adreses rinda 2 Vietējais",
  "EXTRACTED_FIELDS_AddressLine3Local": "Adreses rinda 3 Vietējais",
  "EXTRACTED_FIELDS_IndRefNumber1": "Individuālais atsauces numurs 1",
  "EXTRACTED_FIELDS_IndRefNumber2": "Individuālais atsauces numurs 2",
  "EXTRACTED_FIELDS_IndRefNumber3": "Individuālais atsauces numurs 3",
  "EXTRACTED_FIELDS_IndRefNumber4": "Individuālais atsauces numurs 4",
  "EXTRACTED_FIELDS_IndRefNumber5": "Individuālais atsauces numurs 5",
  "EXTRACTED_FIELDS_Name1": "Vārds 1",
  "EXTRACTED_FIELDS_Name2": "Vārds 2",
  "EXTRACTED_FIELDS_Name3": "Vārds 3",
  "EXTRACTED_FIELDS_Name4": "Vārds 4",
  "EXTRACTED_FIELDS_Name5": "Nosaukums 5",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_1": "Saņēmēja nosaukums 1",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_2": "Saņēmēja nosaukums 2",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_3": "Saņēmēja nosaukums 3",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_4": "Saņēmēja nosaukums 4",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL": "Saņēmēja adrese Pilna",
  "EXTRACTED_FIELDS_IBAN": "IBAN Konta numurs",
  "EXTRACTED_FIELDS_ACCOUNT_NUM": "Konta numurs",
  "EXTRACTED_FIELDS_ISSUER": "Emitents",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY": "Saņēmēja adrese Pilsēta",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE": "Saņēmēja adrese Pasta indekss",
  "EXTRACTED_FIELDS_DAY": "Diena",
  "EXTRACTED_FIELDS_MONTH": "Mēnesis",
  "EXTRACTED_FIELDS_YEAR": "Gads",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_1": "Fakultatīvā vērtība 1",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_2": "Fakultatīvā vērtība 2",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_3": "Fakultatīvā vērtība 3",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_4": "Fakultatīvā vērtība 4",
  "EXTRACTED_FIELDS_ISSUING_STATE_NAME": "Izdevēja valsts nosaukums",
  "EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID": "Priekšpuses dokumenta veids Id",
  "EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID": "Aizmugurējās puses dokumenta tipa id",
  "HASNOCAMERA_TITLE": "Ak, mēs nevarējām atpazīt kameru jūsu ierīcē!",
  "HASNOCAMERA_DESCRIPTION": "Izskatās, ka jūsu ierīcē nav kameras, lūdzu, atkārtojiet mēģinājumu citā ierīcē, kurā ir darboties spējīga kamera, lai jūs varētu veikt visas nepieciešamās darbības.",
  "EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT": "Covid Type Id",
  "USER_INPUT_FIRST_NAME": "Vārds",
  "USER_INPUT_MIDDLE_NAME": "Vidējais vārds",
  "USER_INPUT_LAST_NAME": "Uzvārds",
  "USER_INPUT_DOB": "Dzimšanas datums",
  "USER_INPUT_HOUSE_NAME_NUMBER": "Mājas nosaukums/numurs*",
  "USER_INPUT_STREET_NAME": "Ielas nosaukums*",
  "USER_INPUT_TOWN": "Pilsēta*",
  "USER_INPUT_POSTAL_CODE": "Pasta indekss*",
  "USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE": "piemēram, House/35",
  "USER_INPUT_STREET_NAME_EXAMPLE": "piemēram, Testa iela",
  "USER_INPUT_TOWN_EXAMPLE": "piem., Somewhere",
  "USER_INPUT_POSTAL_CODE_EXAMPLE": "piemēram, CH496 (bez atstarpēm)",
  "SYSTEM_NOT_ABLE": "Sistēma nevarēja skenēt dokumentu",
  "TRY_AGAIN": "Mēģiniet vēlreiz",
  "HINTS_DISABLED_HEADER": "Padomi ir atspējoti manuālajā režīmā",
  "HINTS_DISABLED_DESCRIPTION": "Ja vēlaties iespējot padomus fotoattēla uzņemšanai, pārslēdzieties uz AUTOMĀTISKĀS UZŅEMŠANAS režīmu",
  "YOU_HAVE": "Jums ir",
  "PICTURE_VERIFYING": "Pārbaude...",
  "HOW_TO_TAKE_PHOTO_CORRECTLY": "Kā pareizi uzņemt fotoattēlu",
}